"use client";
import React from "react";
import styled from "styled-components";
import { Container } from "react-bootstrap";
import reactHtmlParser from "react-html-parser";
import { Img } from "@/components/Img";
import { title } from "@/styles/globalStyleVars";

const InnerBanner = ({ img, text, title, subtitle, data, slug }) => {
  return (
    <StyledInnerBanner className="InnerBanner">
      {img && <Img banner={true} src={img} alt={subtitle} />}
      <Container>
        <h5 data-speed={"clamp(1.15)"} className={"subtitle"}>
          {subtitle}
        </h5>
        <h1 data-speed={"clamp(1.18)"}>{reactHtmlParser(title)}</h1>
        {text && <p data-speed={"clamp(1.15)"}>{reactHtmlParser(text)}</p>}
      </Container>
    </StyledInnerBanner>
  );
};

const StyledInnerBanner = styled.section`
  padding-top: calc(561 / 1366 * 100%);
  position: relative;
  background-color: #ddd;

  @media (min-width: 1024px) {
    img {
      height: 120% !important;
      top: -50px !important;
    }
  }
  &:after {
    content: "";
    position: absolute;
    background-color: rgba(0, 0, 0, 0.35);
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
  }

  .container {
    position: absolute;
    //height: 100%;
    //top: 0;
    margin: auto;
    left: 0;
    right: 0;
    bottom: 105px;
    z-index: 2;

    .subtitle {
      font-size: 24px;
      line-height: 32px;
      letter-spacing: 9.6px;
      font-weight: 400;
      color: #ffffff;
      font-family: "Aeonik", Euclid Square, Arial, Helvetica, freesans,
        sans-serif;
    }

    p {
      font-size: 16px;
      line-height: 20px;
      color: #fff;
      margin-top: 20px;
      width: 50%;
      left: 70px;
      position: relative;
      @media (max-width: 991px) {
        width: 100%;
        margin-top: 40px;
        left: 0;
      }
      @media (max-width: 767px) {
        width: 100%;
        margin-top: 40px;
        left: 0;
      }
    }
    h1 {
      //position: absolute;
      left: 70px;
      //bottom: 94px;
      color: #ffffff;
      font-size: 68px;
      font-weight: 600;
      line-height: 72px;
      //text-transform: capitalize;
      z-index: 3;
      position: relative;
      margin-top: 40px;
      letter-spacing: 0.32px;
      font-family: ${title};
      &:after {
        content: "";
        position: absolute;
        top: 50%;
        left: -530px;
        width: 500px;
        height: 2px;
        background: #fff;
        z-index: 9999;
      }

      span {
        font-weight: 600;
        color: #ffffff;
      }
      @media (max-width: 991px) {
        font-size: 52px;
        line-height: 60px;
        margin-top: 20px;
        left: 0;
      }

      @media (max-width: 767px) {
        font-size: 52px;
        line-height: 60px;
        margin-top: 20px;
        left: 0;
      }
    }
  }

  @media (min-width: 767px) {
    .title {
      width: 50%;
    }
  }
  @media (max-width: 1120px) {
    .container {
      bottom: 36px;
    }
  }
  @media (max-width: 991px) {
    padding-top: calc(720 / 1366 * 100%);
    .container {
      bottom: 75px;
    }
  }

  @media (max-width: 767px) {
    //padding-top: 0;
    padding-top: calc(520 / 375 * 100%);
    .container {
      bottom: 36px;
    }

    .title {
      margin-bottom: 40px !important;
    }

    h2 {
      font-size: 40px;
      line-height: 45px;
    }
  }
`;

export default InnerBanner;
